import { app } from '../../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.saaspass-users.user-settings', {
        url: '/user-settings',
        resolve:{
            userSettings
        },
        views: {
            '@company.user-directories': 'companyUserDirectoriesSaaspassUsersUserSettings'
        },
    });
}

/** @ngInject */
function userSettings(companyId, UserSettingsService) {
    return UserSettingsService.getAdminSettings(companyId);
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/all-users/user-settings/user-settings.state.js